import { List } from "immutable";
import { type IPaginationResponse, withPagination } from "utils/pagination";
import { getPaginatedSearchQueryString, type IPaginatedSearchOptions } from "utils/searchUtils";

import { DirectoryGroupModel } from "../models/DirectoryGroupModel";
import { apiReq } from "../utils/api/apiReq";
import { getAsQueryParams } from "./utils";

export async function getPaginatedDirectoryGroups(
  paginationOptions?: IPaginatedSearchOptions,
  options: { withDeleted?: boolean; withUninitialized?: boolean; withUsage?: boolean } = {},
): Promise<IPaginationResponse<DirectoryGroupModel>> {
  return withPagination(
    (directoryGroup: Record<string, unknown>) => DirectoryGroupModel.fromServerData(directoryGroup),
    () => {
      const paginationQueryParams = new URLSearchParams(getPaginatedSearchQueryString(paginationOptions));
      const queryParams = getAsQueryParams({
        ...Object.fromEntries(paginationQueryParams),
        ...options,
      });
      const url = `/v1/directoryGroups?${queryParams}`;
      return apiReq("GET", url);
    },
  );
}

export async function multiGetDirectoryGroups(
  ids: string[],
  options: { includeDeleted?: boolean } = {},
): Promise<List<DirectoryGroupModel>> {
  if (!ids.length) return List<DirectoryGroupModel>();

  const { data } = await apiReq(
    "GET",
    `/v1/directoryGroups/multiGet?withDeleted=${!!options.includeDeleted}&${ids.map((id) => "ids=" + id).join("&")}`,
  );

  return List<DirectoryGroupModel>(data.map((item: unknown) => DirectoryGroupModel.fromServerData(item)));
}
